import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function YalnizlikTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['yalnizlik-testi']} />;
}
